<script>

import appConfig from "@/app.config";
import { Modal } from "bootstrap";
// import store from "@/state/store";
// var state = store._modules.root._children.auth.state;
export default {
  page: {
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },

  
  data() {
    return {
      HrAttendance: [],
      hrEmployees: [],
      page: 1,
      limit: 20,
      tot_pages: 0,
      searchHrAttendance: null,
      HrAttendanceSearchMode: false,
      searchModel: "",
      data: {},
      add_attendance: {},

      // state: state,
    };
  },
  methods: {
    
    addAttendance() {
      // console.log("**********####", this.state);
      this.data.emp_id =this.data.emp.id
        this.http.post("attendance", this.data).then(() => {
                this.get(this.page);
                this.add_attendance.hide()
              });
    },
    editHrAttendance(app) {
      console.log("app", app);
      var data = {
        title: "popups.hr_attendance",
        inputs: [
          {
            model: "employee_id",
            type: "select",
            options: (() => {
              return this.hrEmployees.map((data) => {
                return {
                  value: app.employee_id,
                  label: data.name,
                };
              });
            })(),
            label: this.$t("hr_attendance.employee"),
          },
          {
            model: "check_in",
            type: "time",
            value: app.check_in,
            label: this.$t("hr_attendance.check_in"),
          },
          {
            model: "check_out",
            type: "time",
            value: app.check_out,

            label: this.$t("hr_attendance.check_out"),
          },
          {
            model: "date",
            type: "date",
            value: app.date,
            label: this.$t("hr_attendance.date"),
          },
        ],
        buttons: [
          {
            text: "popups.edit",
            closer: true,
            color: "primary",
            handler: (obj) => {
              this.http.put("emps/attendance", app.id, obj).then(() => {
                this.get(this.page);
              });
            },
          },
          {
            text: "popups.cancel",
            closer: true,
            color: "danger",
            handler: () => {
              console.log("Like Clicked");
            },
          },
        ],
      };
      this.popup.modal(data);
    },

    search() {
      this.HrAttendanceSearchMode = true;
      this.tot_pages = 0;
      this.http
        .post("emps/search-attends", {
          search: new Date(this.searchModel).toISOString().split("T")[0],
          limit: this.limit,
          page: this.page,
          col: "date",
          emp_id: "*",
        })
        .then((res) => {
          this.HrAttendance = res.data;
          console.log("######## files", this.HrAttendance);
        });
    },
    cancelappsearchMode() {
      this.searchModel = "";
      this.HrAttendanceSearchMode = false;
      this.get(this.page);
    },

    getHrAttendance() {
      this.http.get("hr-attendance").then((res) => {
        this.HrAttendance = res.data;
      });
    },
    getHrEmployees() {
      this.http.get("emps").then((res) => {
        this.hrEmployees = res.data;
      });
    },
    getEmps(search) {
      this.http.post("emps/search", { search }).then((res) => {
        if (res.status) {
          this.hrEmployees = res.data;
        }
      });
    },
    deleteHrAttendance(app) {
      var data = {
        title: "popups.delete",
        msg: "popups.delmessage",
      };
      console.log('aaa', app)
      this.popup.confirm(data).then((resp) => {
        if (resp) {
          console.log("###");
          this.http.delete("emps/attendance", app.id).then(() => {
            this.get(this.page);
          });
        }
      });
    },

    get(page) {
      console.log(page);
      this.http
        .post("emps/get-attends", {
          limit: this.limit,
          page: page,
          emp_id: "*",
        })
        .then((res) => {
          this.page = page;
          this.tot_pages = Math.ceil(res.tot / this.limit);
          this.HrAttendance = res.data;
        });
    },
    showLabel(one) {
      return one.name;
    },
  },
  created() {
    this.get(1);
    // this.getHrAttendance();
    this.getHrEmployees();
  },
  mounted() {
    this.add_attendance = new Modal("#addAtendanceModal");
  },
};
</script>

<template>

    <div class="row">
      <div class="col-6 mb-4">
        <div class="search-box chat-search-box w-50">
          <div class="position-relative">
            <input
              @input="search()"
              type="date"
              class="form-control fa-lg text-light"
              :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
              :placeholder="$t('popups.search')"
              v-model="searchModel"
              style="background-color: #2a3042 !important"
            />
            <i class="bx bx-search-alt search-icon text-light"></i>
          </div>
        </div>
      </div>
      <div class="col-6" style="display: flex; justify-content: flex-end">
        <button
          class="btn-close text-light"
          v-if="HrAttendanceSearchMode"
          @click="cancelappsearchMode()"
        ></button>
        <button
          type="button"
          @click="
            data = {};
            add_attendance.show();
          "
          class="btn btn-light float-end mb-4"
        >
          <span
            class="bx bxs-plus-circle float-end fa-2x"
            style="color: #2a3042 !important"
          ></span>
        </button>
      </div>
    </div>

    <table :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'" class="table">
      <thead>
        <tr
          class="text-light text-center"
          style="background-color: #2a3042 !important"
        >
          <th scope="col">{{ $t("hr_attendance.id") }}</th>
          <th scope="col">{{ $t("hr_attendance.employee") }}</th>
          <th scope="col">{{ $t("hr_attendance.check_in") }}</th>
          <th scope="col">{{ $t("hr_attendance.check_out") }}</th>
          <th scope="col">{{ $t("hr_attendance.date") }}</th>

          <th scope="col">{{ $t("hr_attendance.operations") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(app, index) in HrAttendance" :key="app" class="text-center">
          <td>{{ (index += 1) }}</td>
          <td>{{ this.$i18n.locale === 'en' ? app?.name : app?.name_ar }}</td>
          <td>{{ app?.check_in }}</td>
          <td>{{ app?.check_out }}</td>
          <td>{{ app?.date?.split("T")[0] }}</td>

          <td class="d-flex">
            <a
              class="btn btn-primary mx-1"
              @click="editHrAttendance(app)"
              href="javascript: void(0);"
              role="button"
              >{{ $t("popups.edit") }}</a
            >
            <a
              class="btn btn-danger"
              href="javascript: void(0);"
              role="button"
              @click="deleteHrAttendance(app)"
              >{{ $t("popups.delete") }}</a
            >
          </td>
        </tr>
      </tbody>
    </table>
    <!-- end  table -->
    <!-- Button trigger modal -->

    <div v-if="tot_pages > 1">
      <!--   Apps  paginate     -->
      <ul class="pagination pagination-rounded justify-content-center mb-2">
        <li class="page-item" :class="{ disabled: page == 1 }">
          <a
            class="page-link"
            href="javascript: void(0);"
            @click="get(page - 1)"
            aria-label="Previous"
          >
            <i class="mdi mdi-chevron-left"></i>
          </a>
        </li>
        <li
          class="page-item"
          :class="{ active: p == page }"
          v-for="p in tot_pages"
          :key="p"
        >
          <a class="page-link" href="javascript: void(0);" @click="get(p)">{{
            p
          }}</a>
        </li>

        <li class="page-item" :class="{ disabled: page == total_pages }">
          <a
            class="page-link"
            href="javascript: void(0);"
            @click="get(page + 1)"
            aria-label="Next"
          >
            <i class="mdi mdi-chevron-right"></i>
          </a>
        </li>
      </ul>
    </div>

    <!-- Button trigger modal -->

    <!-- Modal -->
    <div
      class="modal fade"
      id="addAtendanceModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modelTitleId"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t("popups.add") }}</h5>
            
          </div>
          <form @submit.prevent="addAttendance()">


          <div class="modal-body">
            <div class="container-fluid"></div>

            <div class="mb-3">
              <label for="" class="form-label">{{ $t("emps.select") }}</label>
              <AutoComplete
                v-model="data.emp"
                :suggestions="hrEmployees"
                :completeOnFocus="true"
                @complete="getEmps($event.query)"
                :optionLabel="showLabel"
                style="color: #333 !important"
                :inputClass="'form-control'"
                class="w-100"
                required
              />
            </div>
            <div class="mb-3">
              <label for="" class="form-label">{{
                $t("hr_attendance.check_in")
              }}</label>

              <input
                v-model="data.check_in"
                type="time"
                class="form-control"
                aria-describedby="helpId"
                placeholder=""
                required
              />
            </div>
            <div class="mb-3">
              <label for="" class="form-label">{{
                $t("hr_attendance.check_out")
              }}</label>

              <input
                v-model="data.check_out"
                type="time"
                class="form-control"
                aria-describedby="helpId"
                placeholder=""
              />
            </div>
            <div class="mb-3">
              <label for="" class="form-label">{{
                $t("hr_attendance.date")
              }}</label>

              <input
                v-model="data.date"
                type="date"
                class="form-control"
                aria-describedby="helpId"
                placeholder=""
                required
              />
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              @click="add_attendance.hide()"
            >
              {{$t('popups.cancel')}}
            </button>
            <button type="submit" class="btn btn-primary">{{$t('popups.add')}}</button>
          </div>
          </form>
        </div>
      </div>
    </div>
    <!--end-->

</template>

<style scoped>
.btn-close {
  position: relative;
  right: 317px;
  top: 6px;
  font-size: 15px;
}
</style>
